import React from "react";
import LogoImg from "../Image/Logo.png";

const Footer = () => {
  return (
    <footer style={{
      backgroundColor: "#1a1a2e",
      color: "#ffffff",
      padding: "20px 40px",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      alignItems: "center",
      marginTop: "auto",
      fontSize: "13px",
      fontFamily: "Open Sans, sans-serif",
    }}>
      <a href="https://jadgroup.goaspendigital.com/" style={{ display: "flex", alignItems: "center" }}>
        <img
          src={LogoImg}
          alt="JAD Group"
          loading="lazy"
          style={{ height: "30px" }}
        />
      </a>
      <div style={{ display: "flex", gap: "20px" }}>
        <a href="https://jadgroup.goaspendigital.com/about-us/" style={{ color: "#ccc", textDecoration: "none" }}>
          About Us
        </a>
        <a href="https://jadgroup.goaspendigital.com/" style={{ color: "#ccc", textDecoration: "none" }}>
          Contact
        </a>
      </div>
      <p style={{ margin: 0, color: "#888" }}>
        Copyright &copy; {new Date().getFullYear()} JAD Group Inc. | Privacy Policy
      </p>
    </footer>
  );
};

export default Footer;
